/** ສະກຸນເງິນທີ່ອະນຸຍາດສຳລັບເອກະສານ — KIP / Baht / USD */
export const DOCUMENT_ALLOWED_CURRENCIES = ["LAK", "THB", "USD"] as const;

export type DocumentCurrencyCode = (typeof DOCUMENT_ALLOWED_CURRENCIES)[number];

export function normalizeDocumentCurrency(
  input: string | null | undefined,
): DocumentCurrencyCode {
  const c = (input ?? "LAK").trim().toUpperCase();
  if ((DOCUMENT_ALLOWED_CURRENCIES as readonly string[]).includes(c)) {
    return c as DocumentCurrencyCode;
  }
  return "LAK";
}
